// extracted by mini-css-extract-plugin
export default {"banner":"ReadOnlyGuard_banner__mmBEL ui_avisoPeligro__aENLN","candado":"ReadOnlyGuard_candado__mtAmK"};